import { faPlug, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router";
import { Button } from "@/components/shadcn/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/shadcn/card";
import { useApiKeyRequestMailto } from "./useApiKeyRequestMailto";

const FEATURE_HIGHLIGHTS = [
  {
    title: "Real-time notifications",
    description: "Get notified the moment records change via an HTTP POST to your endpoint.",
  },
  {
    title: "Automate workflows",
    description: "Trigger downstream systems, sync data, or run custom logic in response to events.",
  },
  {
    title: "Works standalone",
    description: "Use webhooks on their own, or combine with our API for full record detail.",
  },
];

export const WebhookEmptyStateCard = () => {
  const navigate = useNavigate();
  const apiKeyMailto = useApiKeyRequestMailto();

  return (
    <Card className="border-0 shadow-none bg-muted/20">
      <CardContent className="flex flex-col gap-6 p-8">
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-kPurple-100 text-kPurple-500">
              <FontAwesomeIcon icon={faPlug} aria-hidden="true" />
            </span>
            <span className="text-xs font-semibold text-kPurple-500">WEBHOOKS</span>
          </div>
          <h3 className="text-2xl font-semibold">No webhooks configured yet</h3>
          <p className="text-sm text-muted-foreground max-w-xl">
            Get started by creating your first webhook to receive real-time event notifications.
          </p>
          <Button
            className="w-fit bg-kPurple-500 text-white hover:bg-kPurple-600 hover:text-white"
            onClick={() => navigate("/maintenance/webhook/create")}
          >
            Create Webhook
            <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
          </Button>
        </div>

        <p className="text-sm font-medium">What you can do with webhooks</p>

        <div className="grid gap-4 sm:grid-cols-3">
          {FEATURE_HIGHLIGHTS.map((feature) => (
            <Card key={feature.title} className="shadow-none bg-background">
              <CardHeader className="p-4 pb-2">
                <CardTitle className="text-sm font-semibold text-kPurple-500">{feature.title}</CardTitle>
              </CardHeader>
              <CardContent className="p-4 pt-0 text-sm text-muted-foreground">
                {feature.description}
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="flex flex-col gap-2">
          <p className="text-sm font-medium">Want full record detail from our API?</p>
          <p className="text-sm text-muted-foreground max-w-xl">
            Webhook payloads include the ID of the record linked to each event. To look up additional
            detail with our API, you'll need an API key.
          </p>
          <Button asChild variant="outline" className="w-fit">
            <a href={apiKeyMailto} target="_blank" rel="noopener noreferrer">
              Contact us for an API key
              <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
            </a>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
